import installedAtInfoSagas from './info/containers/installed-at-info-sagas';

export default [...installedAtInfoSagas];
